__turbopack_context__.v({
  "isVisibleAnyway": "TopController-module-scss-module__KX_wlW__isVisibleAnyway",
  "regular": "TopController-module-scss-module__KX_wlW__regular",
  "top_controller": "TopController-module-scss-module__KX_wlW__top_controller",
  "wide": "TopController-module-scss-module__KX_wlW__wide",
  "wideOnMobile": "TopController-module-scss-module__KX_wlW__wideOnMobile",
});
